/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {TotpAuthenticatorModel} from "../../models/totp-authenticator-model";

export function initialise2faPost(headers: HttpHeaders, http: HttpClient, rootUrl: string, context?: HttpContext): Observable<StrictHttpResponse<TotpAuthenticatorModel>> {
    const rb = new RequestBuilder(rootUrl, initialise2faPost.PATH, 'post');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<TotpAuthenticatorModel>;
        })
    );
}

initialise2faPost.PATH = '/api/v1/identity/initialise-2fa/google-authenticator';
